import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../environments/environment';
import {
    AdminCustomerConfig,
    AdminRuntimeConfig
} from '../models/admin-runtime-config.model';

@Injectable({
    providedIn: 'root'
})
export class RuntimeConfigService {
    private readonly http = inject(HttpClient);

    private config: AdminRuntimeConfig = {
        customers: []
    };

    async load(): Promise<void> {
        try {
            const runtimeConfig = await firstValueFrom(
                this.http.get<AdminRuntimeConfig>(environment.adminConfigUrl)
            );

            this.config = {
                customers: runtimeConfig?.customers ?? []
            };

            console.log('Runtime config loaded:', this.config);
        } catch (error) {
            console.error('Failed to load runtime admin config.', error);

            this.config = {
                customers: []
            };
        }
    }

    getConfig(): AdminRuntimeConfig {
        return this.config;
    }

    getCustomers(): AdminCustomerConfig[] {
        return this.config.customers ?? [];
    }

    getCustomerByKey(customerKey: string): AdminCustomerConfig | undefined {
        return this.getCustomers().find(customer => customer.key === customerKey);
    }

    getCustomerByFlavour(flavour: string): AdminCustomerConfig | undefined {
        return this.getCustomers().find(customer => customer.flavour === flavour);
    }

    hasCustomers(): boolean {
        return this.getCustomers().length > 0;
    }
}